import React, { useContext, useState } from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import Toolbar from "../components/Toolbar";

const PasswordReset: React.FC = () => {
  const history = useHistory();
  const { resetHash } = useParams<{ resetHash?: string }>();
  const { 
          appLoggedIn, 
          appLoggedInChange,
          appUserData,
          appUserDataChange,
      appToken,
      appTokenChange
        } = useContext(DataContext);

  const { control, handleSubmit } = useForm();

  const [newPass, setNewPass] = useState<string>("");
  const [confirmPass, setConfirmPass] = useState<string>("");
  const [resetEmail, setResetEmail] = useState<string>("");
  const canShowSubmitButton = newPass.length >= 8 && newPass === confirmPass;

  const validateEmail = (email: string) => {
    return email.match(
      /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    );
  };

  const submitNewPassword = () => {
    if (!newPass || !confirmPass) {
      alert("Bitte geben Sie das neue Passwort in beide Felder ein.");
      return;
    }

    if (newPass.length < 8) {
      alert("Das Passwort muss aus mindestens 8 Zeichen bestehen.");
      return;
    }

    if (newPass !== confirmPass) {
      alert("Die Passwörter stimmen nicht überein.");
      return;
    }

    const formData = new FormData();
    formData.append("newPass", newPass);

    let endpoint = "https://login.saint-online.de/funktionen/api2/campusmenu/setPassword.php";

    if (!appLoggedIn) {
      if (!resetHash) {
        alert("Ungültiger Reset-Link. Bitte fordern Sie einen neuen Link an.");
        return;
      }

      if (!resetEmail) {
        alert("Bitte geben Sie Ihre E-Mail-Adresse ein.");
        return;
      }

      if (validateEmail(resetEmail) === null) {
        alert("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        return;
      }

      endpoint = "https://login.saint-online.de/funktionen/api2/campusmenu/resetPassword.php";
      formData.append("resetHash", resetHash);
      formData.append("loginEmail", resetEmail);
    } else {
      formData.append("appToken", appToken);
    }

    fetch(
      endpoint,
      { method: "POST", body: formData }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          alert("Passwort erfolgreich geändert. Bitte melden Sie sich mit Ihrem neuen Passwort an.");
          appLoggedInChange(false);
          appUserDataChange(null);
          appTokenChange(null);
          history.push('/Login');
        }
        else {
          alert(JSON.stringify(data.msg));
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error.msg));
      });
  };



  return (
    <IonPage>
      
      <IonContent fullscreen>
      <IonHeader>
      <Toolbar />
      </IonHeader>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Bitte vergeben Sie ein neues Passwort</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <p>Aus Sicherheitsgründen müssen Sie bei Ihrer ersten Anmeldung ein eigenes Passwort vergeben.</p>
            {!!resetHash && (
              <IonItem>
                <IonLabel position="floating">E-Mail-Adresse</IonLabel>
                <IonInput
                  value={resetEmail}
                  onIonInput={(e:any)=>setResetEmail(e.detail.value || "")}
                  type="email"
                />
              </IonItem>
            )}
            <IonItem>
              <IonLabel position="floating">Neues Passwort</IonLabel>
              <IonInput value={newPass} onIonInput={(e:any)=>setNewPass(e.detail.value || "")} type="password"/>
            </IonItem>
            <IonItem>
              <IonLabel position="floating">Passwort bestätigen</IonLabel>
              <IonInput value={confirmPass} onIonInput={(e:any)=>setConfirmPass(e.detail.value || "")} type="password"/>
            </IonItem>
            <p>Hinweis: Das Passwort muss aus mindestens 8 Zeichen bestehen.</p>
            {canShowSubmitButton && (
              <IonButton expand="block" onClick={submitNewPassword}>Passwort ändern</IonButton>
            )}
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default PasswordReset;
